import React, { useEffect, useRef, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import { trackSignUp } from '../utils/analytics';
import './LegalPage.css';

const ConfirmSubscription = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('confirming');
  const requested = useRef(false);

  useEffect(() => {
    if (requested.current) return;
    requested.current = true;

    const email = searchParams.get('email');
    const token = searchParams.get('token');
    if (!email || !token) {
      setStatus('error');
      return;
    }

    const confirm = async () => {
      try {
        await axios.post(
          'https://thx8odn37g.execute-api.us-west-2.amazonaws.com/prod/subscribe',
          { action: 'confirm', email, token }
        );
        trackSignUp('newsletter_confirmed');
        setStatus('confirmed');
      } catch (err) {
        setStatus('error');
      }
    };
    confirm();
  }, [searchParams]);

  return (
    <div className="legal-page">
      <Helmet>
        <title>Confirm subscription | Jajoga Insights</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="container" role="status" aria-live="polite">
        {status === 'confirming' && <h1>Confirming your subscription…</h1>}
        {status === 'confirmed' && (
          <>
            <h1>You're subscribed</h1>
            <p>
              Welcome to Jajoga Insights. You'll get weekly insights on salon performance,
              data-driven decision making, and what's working for multi-location operators.
            </p>
            <p><Link to="/blog">Read the latest insights</Link></p>
          </>
        )}
        {status === 'error' && (
          <>
            <h1>This link didn't work</h1>
            <p>
              The confirmation link is invalid or has expired. You can sign up again from
              the <Link to="/">home page</Link>.
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default ConfirmSubscription;
